import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Single axios instance for admin — always sends cookies.
export const adminApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Helper for auth — public site is anonymous, so this is admin-only
export async function fetchMe() {
  const r = await adminApi.get("/auth/me");
  return r.data;
}

export async function logout() {
  await adminApi.post("/auth/logout");
}
